import { Injectable } from '@angular/core';
import { PROFILEVIEW } from 'src/app/config';
import { RouterStateSnapshot, Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';

@Injectable({
  providedIn: 'root'
})
export class KycguardService {

  constructor(private api:ApiService,private route:Router) { }
  canActivate(route, state: RouterStateSnapshot) {
          this.api.Post(PROFILEVIEW, {}).then(data=>{
            let kyc=data['kyc'];
            if(kyc==null)
            {
        
              this.api.onFail('Your account is not verified','KYC not Verified');
              return false;
              
            }
            else{
              return true;
            }
            
          
      }).catch(d=>{
        if( d.status == 503){
          this.api.onFail('Your session is expired please login again','Login');
          this.api.setGoto();
          this.api.setlogin(0);
          this.api.logout();
          setTimeout(() => {
          this.route.navigate(['/login']);
          },1000);
        } else{
          console.log(d);
        }
      });
  }
}
